/* eslint-disable */

import React,{Component} from 'react';
import Header from '../Headers';
import url from '../../config/url';
import Select from 'react-select';
import BooksDatatable from './booksDatatable'

import axios from 'axios';
import Singleton from '../../sock';
import fetchBookNo from '../fetchCode';
import LoaderComponent from '../cAjaxLoader';
import { ToastContainer } from 'react-toastr';
const $ = require('jquery');

var books = [];
var batchTypeID = 0;
var bookno = [];
var branchMetaData = [];

const myStyle = {
    marginTop:30,
    rows: 10,
}
Array.prototype.contains = function(v) {
    for(var i = 0; i < this.length; i++) {
        if(this[i] === v) return true;
    }
    return false;
};

Array.prototype.unique = function() {
    var arr = [];
    for(var i = 0; i < this.length; i++) {
        if(!arr.includes(this[i])) {
            arr.push(this[i]);
        }
    }
    return arr; 
}
const colArr = ['Book Number','Isbn','Message',""] ;

class AddBooks extends Component{
    constructor(props){
        super(props);
        this.state = {
            booksDetails:new Array(),
            branches:new Array(),
            tData:[],
            resetTableBody:false,
            showLoader:false,
            ownerBranch:'',
            originalBranch:'',
            disableAdd:true,
            disableClear:true,
            isDonatedBook: false,
            showUserField:false,
            donatedBy:""
        }
        // this.handleGenerateClick = this.handleGenerateClick.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleIsbnValueChange = this.handleIsbnValueChange.bind(this);
        this.handleDonatedBookChange = this.handleDonatedBookChange.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
    }

    componentWillMount(){
        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    componentDidMount(){
        this.sock.onmessage = msg =>{
            //for java
            if(typeof(msg.data) === 'string'){
                this.fetchCode(msg.data);
            }
            else{
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function() {
                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)
           }
        };

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to kiosk. Please check your connection and refresh");
            
        }

        this.sock.onclose = (evt) =>{
            console.log(evt);
        }
        
        // calling branchMetaData api
        if(branchMetaData.length === 0)
        {
            axios.get(url + 'generateBatchMetadata').then(response => {
             
                if(response.data.status)
                {
                    var branches = response.data.successObject.branches;
                    
                    for(let i = 0 ; i < branches.length; i++){
                        
                        var obj = {
                            value:branches[i].id,
                            label:branches[i].id  + '-' + branches[i].branchName
                        }
                        branchMetaData.push(obj);
                    }
                }
            })
            .catch(err =>{
                console.log(err);
                this.refs.container.error(err.response)
                // console.log(err);
            })
        }

        this.setState({branches:branchMetaData});
        
    }
    componentWillUnmount(){
        bookno=[];
        Singleton.closeSocket(this.sock);
    }


    /************** start fetching bookno from kiosk if branches are selected*********** */
    handleStart(){
        if(this.state.ownerBranch === ''){
            this.refs.container.error('Please select owner branch');
            return;
        }else if(this.state.originalBranch === ''){
            this.refs.container.error('Please select original branch');
            return;
        }
        this.setState({startListening:true,disableAdd:false,disableClear:false});
    }

    handleClear(){
        // this.fetchCode(Math.floor(Math.random() * 20))
        let t = $('#tbl').DataTable();
        t.clear().draw();
        bookno = [];
    }

    //************* proccessBatchapi (Sendout api) ****************8 */

    handleAdd(){
        let donatedBy = this.state.donatedBy;
        if(this.input){
            donatedBy = this.input.value;
        }
        let originalBranchID = this.state.originalBranch.value;
        let ownerBranchId = this.state.ownerBranch.value;
        let createdAt = sessionStorage.getItem('at');
        let createdBy = sessionStorage.getItem('by');
        
        let t = $('#tbl').DataTable();
        let dataToPost = [];

        t.rows({search: 'applied'}).every( function ( rowIdx, tableLoop, rowLoop ) {
            
            // this is the only way I can find of getting cells from the current row,
            // but this checks all cells in all rows for each row (too slow for large tables)
            let cells = ''
            cells = this.cells(function (cellIdx, data, node) {
              return (cellIdx.row == rowIdx);
            });
            let i = 0; 
            cells.every(function() {
              if(i == 0){

                let titleId = $(`#${this.data()}`).attr('data-titleId');
                let isbnId = $(`#${this.data()}`).attr('data-isbnId')
                  dataToPost.push({
                    "createdAt":createdAt,
                    "createdBy":createdBy,
                    "isbnId":isbnId,
                    "titleId":titleId,
                    "origLocationBranchId":originalBranchID,
                    "ownerBranchId":ownerBranchId,
                    "tag":this.data(),
                    "donatedBy":donatedBy
                  })
              }
              i++;
                // console.log(this.data());
            });
          });
          this.setState({showLoader:true})
          axios.post(url + "saveBook",dataToPost).then(res=>{
            console.log(res.data)
            this.setState({showLoader:false})
            console.log(t.rows[0])
            if(res.data.status){
                t.clear().draw();
                var tblData = res.data.successObject;
                tblData.forEach(element => {
                    if(element.status){
                        t.row.add([
                            element.bookTag,
                            element.isbnId,
                            element.successMsg,
                            ""
                        ]).draw();
                    }else{
                        t.row.add([
                            `<span style = "color:red">${element.bookTag}</span>`,
                            `<span style = "color:red">${element.isbnId}</span>`,
                            `<span style = "color:red">${element.errorMsg}</span>`,
                            ""
                        ]).draw();
                    }
                });
            }else{
                this.refs.container.error(res.data.errorDescription)
            }
          }).catch(err =>{
              console.log(err)
              this.refs.container.error('Something went wrong!!')
          })
          console.log(dataToPost)
        
    }
    
    
    //calling the sort api 
    fetchCode(value)
    {
        if(this.state.startListening){
            console.log(books)
            if(books.includes(value)){
                return;
            }else{
                let t =$('#tbl').DataTable();
                t.row.add([value,
                    `<input id = ${value} type = text />`,
                    "",
                ""]).draw();               
            
                books.push(value)
                
            }
        }else{
            this.refs.container.warning('Hit start to start scanning')
        }
        

    }

    handleIsbnValueChange(value,element){
        this.setState({showLoader:true})
       
        axios.get(`${url}getIsbnDataForBook?isbn=${value}`).then(res =>{
            this.setState({showLoader:false})
            if(res.data.status){
                let titleId = res.data.successObject.titleId;
                let isbnId = res.data.successObject.isbnId
                $(element).attr('data-titleId', titleId);
                $(element).attr('data-isbnId', isbnId);
                
            }else{
                
                this.refs.container.error(res.data.errorDescription)
            }
        }).catch(err=>{

            this.setState({showLoader:false})
            this.refs.container.error('Something went wrong!!')

        })
    }

    handleDonatedBookChange(value){
        this.setState({isDonatedBook: value,showUserField:true })
    }
    render(){
        return(
            <React.Fragment>
                <LoaderComponent showLoader = {this.state.showLoader}>
                <ToastContainer 
                    ref = "container"    
                    className="toast-top-right"
                />
                <Header hname = "Add Books"/>

                <div className="row" style = {{marginTop:30}}>
                
                <div className="col-sm-3">
                    <Select
                        name="owner-branch"
                        value = {this.state.ownerBranch}
                        onChange = {value => this.setState({ownerBranch: value })}
                        
                        options={this.state.branches}
                        clearable={false}
                        placeholder='Owner Branch'
                    />
                </div>
                <div className="col-sm-3">
                    <Select style = {{marginBottom:5}}
                        name="original-branch"
                        value = {this.state.originalBranch}
                        clearable={false}
                        options={this.state.branches}
                        onChange = {value => this.setState({originalBranch: value })}                            
                        placeholder='Original Branch'
                        
                    />
                </div>
                   
                    <div className="col-sm-2">
                    
                        <Select style = {{marginBottom:5}}
                            name="donated-book"
                            value = {this.state.isDonatedBook}
                            clearable={false}
                            options={[{value:true,label:'Yes'},{value:false,label:'No'}]}
                            onChange = {this.handleDonatedBookChange}                  
                            placeholder='Donated book'
                                    
                        />
                    </div>
                    {this.state.showUserField ? 
                    <div className="col-sm-4">
                        <label>Enter membership no/email</label>
               
                        <input
                            type="text"
                            ref={(input) => { this.input = input }}
                            />
               
                    </div>: ''}
                    
            </div>

                <div className = "row">
                <div style = {{margin: 10}} className = "col-sm-6 btngroup btn-toolbar">
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleStart} >Start</button>
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleAdd}   disabled = {this.state.disableAdd}>Add</button>
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleClear} disabled = {this.state.disableClear}>Clear</button>
                    </div> 
                    <div className = "col-lg-10">
                        <BooksDatatable 
                            changedIsbn = {this.handleIsbnValueChange}
                            columns = {colArr}
                            tData = {this.state.tData}
                        />
                    </div>  
                
                </div>
                </LoaderComponent>
            </React.Fragment>
        )
    }
}

export default AddBooks;


// WEBPACK FOOTER //
// ./src/Components/AddBooksToTitle/addBooks.js